import React, { useContext, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { Typography } from '@mui/material';

import { t } from '../../../../../../utils/i18next';
import { storeContext } from '../../../../../context';
import RightRailLink from './RightRailLink';

const CustomProviderMessage = observer(({ children }) => {
  const {
    translations: { currentLanguage, hasTranslation },
    settings
  } = useContext(storeContext);

  const setting = useMemo(
    () => settings.get('custom_right_rail_link'),
    [settings]
  );

  const customMessageKey = setting
    ? 'custom_messages.total_side_bar_message'
    : null;

  const hasCustomMessage = useMemo(() => {
    const keys = ['headline', 'content', 'cta'];
    if (setting && setting.link) {
      //assert all translations exist
      return keys.every(key => hasTranslation(`${customMessageKey}.${key}`));
    }
    return false;
  }, [settings]);

  const hasExtraLink =
    hasCustomMessage &&
    !!setting.extra_link &&
    hasTranslation(`${customMessageKey}.extra_link_cta`);

  return (
    <>
      {hasCustomMessage && (
        <>
          <div data-testid="custom-provider-message">
            <Typography variant={'subtitle2'} gutterBottom>
              {t(`${customMessageKey}.headline`)}
            </Typography>
            <Typography gutterBottom>
              {t(`${customMessageKey}.content`, {
                interpolation: { escapeValue: false }
              })}
            </Typography>
            <RightRailLink
              cta={`${customMessageKey}.cta`}
              link={setting.link}
              id={'custom-message'}
              dataTestId={'custom-message-link'}
            />
            {hasExtraLink && (
              <RightRailLink
                cta={`${customMessageKey}.extra_link_cta`}
                link={setting.extra_link}
                id={'custom-message-extra-link'}
                dataTestId={'custom-message-extra-link'}
              />
            )}
          </div>
          {children}
        </>
      )}
    </>
  );
});

export default CustomProviderMessage;
